
import { defineComponent } from "vue";
import { useI18n } from "vue-i18n";
import { mapState, mapGetters } from "vuex";
import { RootGetters } from "@/store/getters";
import IbIcons from "@/components/icons/ib-icons.vue";

export default defineComponent({
  setup() {
    const { t } = useI18n({
      inheritLocale: true,
      useScope: "local",
    });
    return { t };
  },
  components:{
    IbIcons
  },
  computed: {
    ...mapState(["activeHeatmaps"]),
    ...mapGetters({ config: RootGetters.CONFIG }),
    cellsTRenderInLegend() {
      let cellsObject = JSON.parse(JSON.stringify(this.quantificationLegendObjects.cells));
      if (this.config.use_reduced_version_HER2_heatmap) {
        delete cellsObject.not_invasive;
      }
      return cellsObject;
    },
  },
  watch: {
    activeHeatmaps(newHeatmap, oldHeatmap) {
      if (newHeatmap) {
        let currentHeatmapClassification = newHeatmap.find((hm) => hm.isActive)?.classification;
        if (currentHeatmapClassification) {
          this.selectiveLegendItemHeatmap = this.quantificationLegendObjects.cells[
            currentHeatmapClassification
          ]
            ? currentHeatmapClassification
            : "";
        } else {
          this.selectiveLegendItemHeatmap = "";
        }
      }
    },
  },
  methods: {
    computeTextStyle(key) {
      if (this.selectiveLegendItemHeatmap && key !== this.selectiveLegendItemHeatmap) {
        return "grayed-out";
      }
      return "";
    },
    computeIconStyle(key) {
      if (this.selectiveLegendItemHeatmap && key !== this.selectiveLegendItemHeatmap) {
        let styleClass =
          this.quantificationLegendObjects.cells[key].backgroundColor === "#ffffff00"
            ? "grayed-out-icon-hollow"
            : "grayed-out-icon-full";
        return styleClass;
      }
      return "";
    },
  },
  data() {
    return {
      selectiveLegendItemHeatmap: "",
      //this data is hard coded but in the future should come as part
      // of the heatmap data from the server
      quantificationLegendObjects: {
        cells: {
          "Intense complete": {
            backgroundColor: "red",
            width: "10px",
            height: "10px",
            border: "2px solid red",
            borderRadius: "50%",
            text: "heatmapLegendQuantification.cells.intenseComplete",
          },
          "Intense incomplete": {
            backgroundColor: "#ffffff00",
            width: "10px",
            height: "10px",
            border: "2px solid red",
            borderRadius: "50%",
            text: "heatmapLegendQuantification.cells.intenseIncomplete",
          },
          "Moderate complete": {
            backgroundColor: "rgb(255,255,0)",
            width: "10px",
            height: "10px",
            border: "2px solid rgb(2255,255,0)",
            borderRadius: "50%",
            text: "heatmapLegendQuantification.cells.moderateComplete",
          },
          "Moderate incomplete": {
            backgroundColor: "#ffffff00",
            width: "10px",
            height: "10px",
            border: "2px solid rgb(255,255,0)",
            borderRadius: "50%",
            text: "heatmapLegendQuantification.cells.moderateIncomplete",
          },
          "Faint staining": {
            backgroundColor: "#ffffff00",
            width: "10px",
            height: "10px",
            border: "2px solid #00ff00",
            borderRadius: "50%",
            text: "heatmapLegendQuantification.cells.faintIncomplete",
          },
          "Not stained": {
            backgroundColor: "#ffffff00",
            width: "10px",
            height: "10px",
            border: "2px solid blue",
            borderRadius: "50%",
            text: "heatmapLegendQuantification.cells.notStained",
          },
          not_invasive: {
            backgroundColor: "rgb(30,30,30)",
            width: "5px",
            height: "5px",
            border: "1px solid rgb(30,30,30)",
            borderRadius: "50%",
            text: "heatmapLegendQuantification.cells.notInvasive",
          },
          unclassified: {
            backgroundColor: "rgb(148, 0, 211)",
            width: "5px",
            height: "5px",
            border: "1px solid rgb(148, 0, 211)",
            borderRadius: "50%",
            text: "heatmapLegendQuantification.cells.unclassified",
          },
        },
        curves: {
          "Invasive AOI": {
            backgroundColor: "red",
            width: "18px",
            height: "4px",
            border: "1px solid red",
            text: "heatmapLegendQuantification.areaContours.invasiveAOI.text",
            info: null,
          },
          Control: {
            backgroundColor: "rgb(32,88,103)",
            width: "18px",
            height: "4px",
            border: "1px solid rgb(32,88,103)",
            text: "heatmapLegendQuantification.areaContours.control.text",
            info: "heatmapLegendQuantification.areaContours.control.info",
          },
        },
      },
    };
  },
});
